module.exports = __webpack_public_path__ + "static/media/4.924fd539.jpeg";